import React from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import Colors from '../../constants/Colors';
import Button from '../../components/Button';
import { H4, P } from '../../components/Typography';

const StyledExampleScreenView = styled.ScrollView`
  background: ${Colors.background};
  padding: 24px;
`;

const StyledButton = styled(Button)`
  width: auto;
  align-items: center;
  align-self: center;
  margin-bottom: 12px;
`;

const StyledText = styled.Text`
  font-size: 20px;
  padding: 20px;
`;

const StyledMarginTopView = styled.View`
  margin-top: 100;
`;

const ExampleScreen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();

  const buttons = [
    { title: 'Example Header Tab View', screen: 'ExampleHeaderTabViewScreen' },
    { title: 'Study Card', screen: 'StudyCardScreen' },
    { title: 'Encouragement View', screen: 'EncouragementViewExampleScreen' },
    { title: 'Wellness Category List', screen: 'WellnessCategoryListScreen' },
    { title: 'Today Empty State View', screen: 'TodayEmptyStateScreen' },
    { title: 'Calendar Day Scroll', screen: 'CalendarDayScrollExampleScreen' },
    { title: 'Study Journey Chart', screen: 'StudyJourneyChartScreen' },
    {
      title: 'Study Notification List',
      screen: 'StudyNotificationListExampleScreen'
    },
    {
      title: 'Button Styling',
      screen: 'ExampleButtonScreen'
    },
    {
      title: 'List Styling',
      screen: 'ExampleListScreen'
    },
    { title: 'Prompt List', screen: 'PromptListExampleScreen' },
    {
      title: 'Web View Modal',
      screen: 'WebViewModalExampleScreen'
    },
    {
      title: 'Discover Category List',
      screen: 'DiscoverCategoryListExampleScreen'
    },
    {
      title:
        Platform.OS === 'ios'
          ? 'HealthKit Integration'
          : 'Google Fit Integration',
      screen: 'HealthKitGoogleFitSampleScreen'
    },
    { title: 'Compare Chart', screen: 'CompareChartScreen' },
    { title: 'Data Tracker', screen: 'DataTrackerChartScreen' },
    { title: 'Gauge Chart', screen: 'GaugeChartScreen' },
    { title: 'Calendar', screen: 'CalendarScreen' },
    {
      title: 'Rolling Average Chart',
      screen: 'RollingAverageChartExampleScreen'
    },
    { title: 'Date Input Calendar', screen: 'SurveyFormDateInput' },
    {
      title: 'Test Dynamic Form',
      screen: 'TestDynamicFormScreen'
    },
    {
      title: 'Time Picker',
      screen: 'TimePickerScreen',
      modal: true
    },
    {
      title: 'Sleep: Study 1',
      subTitle: 'Name: Rosalind Franklin \nIntervention: Vitamin C',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 1
    },
    {
      title: 'Sleep: Study 2',
      subTitle: 'Name: Rosalind Franklin \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 2
    },
    {
      title: 'Sleep: Study 1 (No Change)',
      subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 3
    },
    {
      title: 'Sleep: Study 2 (Variable)',
      subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 4
    },
    {
      title: 'Sleep: Study 3 (Tight - 30)',
      subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 5
    },
    {
      title: 'Sleep: Study 4 (Tight - 60)',
      subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 6
    },
    {
      title: 'Sleep: Study 5 (Tight - neg 30)',
      subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
      screen: 'SleepStudyResultsExampleScreen',
      studyNumber: 7
    },
    {
      title: 'Pain: Study 1',
      subTitle: 'Name: Painful Paul \nIntervention: Vitamin C',
      screen: 'PainStudyResultsExampleScreen',
      studyNumber: 1
    },
    {
      title: 'Pain: Study 2',
      subTitle: 'Name: Painful Paul \nIntervention: ReLeaf',
      screen: 'PainStudyResultsExampleScreen',
      studyNumber: 2
    }
    // {
    //   title:
    //     Platform.OS === 'ios'
    //       ? 'HealthKit Integration'
    //       : 'Google Fit Integration',
    //   screen: 'HealthKitGoogleFitSampleScreen'
    // },
    // { title: 'Compare Chart', screen: 'CompareChartScreen' },
    // { title: 'Data Tracker', screen: 'DataTrackerChartScreen' },
    // { title: 'Gauge Chart', screen: 'GaugeChartScreen' },
    // { title: 'Calendar', screen: 'CalendarScreen' },
    // {
    //   title: 'Rolling Average Chart',
    //   screen: 'RollingAverageChartExampleScreen'
    // },
    // { title: 'Date Input Calendar', screen: 'SurveyFormDateInput' },
    // {
    //   title: 'Test Dynamic Form',
    //   screen: 'TestDynamicFormScreen'
    // },
    // {
    //   title: 'Button Styling',
    //   screen: 'ExampleButtonScreen'
    // },
    // {
    //   title: 'Time Picker',
    //   screen: 'TimePickerScreen',
    //   modal: true
    // },
    // {
    //   title: 'Sleep: Study 1',
    //   subTitle: 'Name: Rosalind Franklin \nIntervention: Vitamin C',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 1
    // },
    // {
    //   title: 'Sleep: Study 2',
    //   subTitle: 'Name: Rosalind Franklin \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 2
    // },
    // {
    //   title: 'Sleep: Study 1 (No Change)',
    //   subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 3
    // },
    // {
    //   title: 'Sleep: Study 2 (Variable)',
    //   subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 4
    // },
    // {
    //   title: 'Sleep: Study 3 (Tight - 30)',
    //   subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 5
    // },
    // {
    //   title: 'Sleep: Study 4 (Tight - 60)',
    //   subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 6
    // },
    // {
    //   title: 'Sleep: Study 5 (Tight - neg 30)',
    //   subTitle: 'Name: Sleepy Sue \nIntervention: Sleep Z Gummy',
    //   screen: 'SleepStudyResultsExampleScreen',
    //   studyNumber: 7
    // },
    // {
    //   title: 'Pain: Study 1',
    //   subTitle: 'Name: Painful Paul \nIntervention: Vitamin C',
    //   screen: 'PainStudyResultsExampleScreen',
    //   studyNumber: 1
    // },
    // {
    //   title: 'Pain: Study 2',
    //   subTitle: 'Name: Painful Paul \nIntervention: ReLeaf',
    //   screen: 'PainStudyResultsExampleScreen',
    //   studyNumber: 2
    // }
  ];

  return (
    <StyledExampleScreenView>
      {Platform.OS === 'web' && <StyledMarginTopView></StyledMarginTopView>}
      <H4 padding={1}>Experiment Zone</H4>
      <P padding={2}>
        This section is for our product/engineering team to test new features.
      </P>
      {buttons.map(({ title, screen, subTitle, studyNumber }) => {
        return (
          <StyledButton
            outlined
            key={title}
            onPress={() => {
              navigation.navigate(screen, { title, subTitle, studyNumber });
            }}
          >
            <StyledText>{title}</StyledText>
          </StyledButton>
        );
      })}
    </StyledExampleScreenView>
  );
};

export default ExampleScreen;
